"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogueOfferTooltip = void 0;
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OFFER_TOOLTIP_LEAVE_DELAY = 2000;
const CatalogueOfferTooltip = ({
  children,
  offerLabelSmallerOnMobile,
  title
}) => {
  const {
    onClose,
    onOpen,
    onToggle,
    open
  } = (0, _presentationHooks.useDisclose)();
  const toggleTooltip = (0, _react.useCallback)(e => {
    e.preventDefault();
    onToggle();
  }, [onToggle]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ClickAwayListener, {
    mouseEvent: false,
    onClickAway: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Tooltip, {
      disableTouchListener: true,
      leaveDelay: OFFER_TOOLTIP_LEAVE_DELAY,
      open: open,
      placement: "bottom-start",
      PopperProps: {
        disablePortal: true
      },
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        children: title
      }),
      "data-testid": _common.CATALOGUE_OFFER_TOOLTIP,
      onClose: onClose,
      onOpen: onOpen,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TooltipFab, {
        disableRipple: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        onTouchEnd: toggleTooltip,
        children: children
      })
    })
  });
};
exports.CatalogueOfferTooltip = CatalogueOfferTooltip;
//# sourceMappingURL=CatalogueOfferTooltip.js.map